import { render, staticRenderFns } from "./setRecycle.vue?vue&type=template&id=34c76d22&scoped=true"
import script from "./setRecycle.vue?vue&type=script&lang=js"
export * from "./setRecycle.vue?vue&type=script&lang=js"
import style0 from "./setRecycle.vue?vue&type=style&index=0&id=34c76d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c76d22",
  null
  
)

export default component.exports